import { inject } from '@angular/core';
import { CanMatchFn, GuardResult, Route, Router, UrlSegment } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { Role } from 'app/core/user/user.types';
import { Observable, of, switchMap, take } from 'rxjs';

export const RoleGuard = (roles: Role[]): CanMatchFn => {
    return (route: Route, segments: UrlSegment[]): Observable<GuardResult> => {
        const authService: AuthService = inject(AuthService);
        const router = inject(Router);

        return authService.check().pipe(
            take(1),
            switchMap((authenticated: boolean) => {

                if (!authenticated) {
                    router.navigate(['/sign-in']);
                    return of(false);
                }

                const user = authService.user();

                if (!user || !roles.includes(user.role)) {
                    return of(false);
                }
                return of(true);
            })
        );
    };
};